<template>
  <v-container fluid class="dashboard-container">
    <v-col
      v-if="esAdministrador"
      cols="12"
      md="12"
    >
      <v-autocomplete
        v-model="idcontratistas"
        :items="contratistas"
        label="Empresa Contratista"
        dense
        clearable
        @change="cambiarContratista"
      />
    </v-col>


    <!-- ==========================
         KPI SUPERIORES
    =========================== -->

    <v-row dense>

      <v-col
        cols="12"
        sm="6"
        md="2"
        v-for="item in tarjetasKpi"
        :key="item.nombre"
      >

        <v-card
          class="kpi-card"
          :class="{ 'kpi-destacado': item === tarjetasKpi[0] }"
          elevation="2"
        >

          <div class="kpi-header">

            <div>

              <div
                class="kpi-number"
                :style="{color:item.color}"
              >
                {{ item.valor }}
              </div>


              <div class="kpi-label">
                {{ item.nombre }}
              </div>

            </div>


            <v-icon
              size="42"
              :color="item.color"
            >
              {{ item.icon }}
            </v-icon>


          </div>


        </v-card>

      </v-col>

    </v-row>





    <!-- ==========================
         PRIMER BLOQUE INFORMACION
    =========================== -->


    <v-row dense class="mt-5">


      <!-- RESUMEN FINANCIERO -->

      <v-col cols="12" md="4">

        <v-card class="panel-card">

          <v-card-title>
            <v-icon left color="#C05026">
              mdi-finance
            </v-icon>
            Resumen financiero
          </v-card-title>


          <v-card-text>

            <v-row dense>

              <!-- FACTURAS VENCIDAS -->
              <v-col cols="12">

                <div class="finance-box vencidas">

                  <div class="finance-icon">
                    <v-icon size="45" color="#C05026">
                      mdi-file-alert-outline
                    </v-icon>
                  </div>


                  <div class="finance-main">

                    <div class="finance-number">
                      {{ resumenFinanciero.facturas_vencidas.cantidad }}
                    </div>

                    <div class="finance-label">
                      FACTURAS VENCIDAS
                    </div>

                  </div>


                  <div class="finance-money">

                    <strong>
                      S/ {{ resumenFinanciero.facturas_vencidas.monto_soles.toFixed(2) }}
                    </strong>

                    <small>
                      MONTO TOTAL (S/)
                    </small>


                    <strong class="usd">
                      $ {{ resumenFinanciero.facturas_vencidas.monto_dolares.toFixed(2) }}
                    </strong>

                    <small>
                      MONTO TOTAL (US$)
                    </small>

                  </div>


                </div>


              </v-col>




              <!-- FACTURAS POR VENCER -->

              <v-col cols="12">

                <div class="finance-box por-vencer">


                  <div class="finance-icon">

                    <v-icon size="45" color="#D49B00">
                      mdi-calendar-clock
                    </v-icon>

                  </div>



                  <div class="finance-main">


                    <div class="finance-number">
                      {{ resumenFinanciero.facturas_por_vencer.cantidad }}
                    </div>


                    <div class="finance-label">
                      FACTURAS POR VENCER
                    </div>


                    <div class="finance-sub">
                      Próximos {{ resumenFinanciero.facturas_por_vencer.dias }} días
                    </div>


                  </div>





                  <div class="finance-money">


                    <strong>
                      S/ {{ resumenFinanciero.facturas_por_vencer.monto_soles.toFixed(2) }}
                    </strong>

                    <small>
                      MONTO TOTAL (S/)
                    </small>



                    <strong class="usd">
                      $ {{ resumenFinanciero.facturas_por_vencer.monto_dolares.toFixed(2) }}
                    </strong>


                    <small>
                      MONTO TOTAL (US$)
                    </small>


                  </div>


                </div>


              </v-col>


            </v-row>


          </v-card-text>


        </v-card>


      </v-col>

      <v-col cols="12" md="3">
        <v-card class="panel-card">

          <v-card-text>

            <v-row align="center">

              <!-- Icono -->
              <v-col cols="3" class="text-center">
                <v-icon
                  size="50"
                  color="#0095A9"
                >
                  mdi-bullhorn-outline
                </v-icon>
              </v-col>

              <!-- Total -->
              <v-col cols="9">
                <div class="requerimientos-total">
                  {{ indicadoresRequerimientos.total }}
                </div>

                <div class="requerimientos-title">
                  REQUERIMIENTOS PUBLICADOS
                </div>

                <div class="requerimientos-subtitle">
                  Presente Mes
                </div>
              </v-col>

            </v-row>

            <v-divider class="my-4"></v-divider>

            <v-row>

              <v-col cols="6" class="text-center">

                <div class="detalle-numero">
                  {{ indicadoresRequerimientos.publicados }}
                </div>

                <div class="detalle-texto">
                  PUBLICADOS<br>
                  POR LA CONTRATISTA
                </div>

              </v-col>

              <v-col cols="6" class="text-center">

                <div class="detalle-numero">
                  {{ indicadoresRequerimientos.regulados }}
                </div>

                <div class="detalle-texto">
                  REGULARIZADOS<br>
                </div>

              </v-col>

            </v-row>

            <div class="text-center mt-4">
              <router-link
                to="/misrequerimientos"
                class="ver-link"
              >
                Ver requerimientos
                <v-icon small color="#0095A9">
                  mdi-arrow-right
                </v-icon>
              </router-link>
            </div>

          </v-card-text>

        </v-card>
      </v-col>

      <!-- <v-col cols="12" md="5">
        <v-card class="panel-card">

          <v-card-title class="panel-title">
            CONTRATOS CON PROVEEDORES LOCALES
          </v-card-title>

          <v-card-text>

            <v-row align="center">

              <v-col cols="5">

                <div class="monto-box">

                  <div class="monto-label">
                    MONTO CONTRATADO (S/)
                  </div>

                  <div class="monto-value">
                    S/ {{ contratosLocales.montoContratado }}
                  </div>

                </div>

              </v-col>

              <v-col cols="4">

                <div class="monto-box">

                  <div class="monto-label">
                    MONTO CONSUMIDO (S/)
                  </div>

                  <div class="monto-value">
                    S/ {{ contratosLocales.montoConsumido }}
                  </div>

                </div>

              </v-col>

              <v-col
                cols="3"
                class="text-center"
              >

                <div class="icon-circle">

                  <v-icon
                    size="72"
                    color="#0095A9"
                  >
                    mdi-map-marker-account-outline
                  </v-icon>

                </div>

              </v-col>

            </v-row>



            <v-progress-linear
              :value="contratosLocales.porcentaje"
              height="22"
              color="#0095A9"
              background-color="#E6E6E6"
              rounded
            >

              <strong class="white--text">
                {{ contratosLocales.porcentaje }}%
              </strong>

            </v-progress-linear>



            <div class="porcentaje-text">

              % CONSUMIDO CON PROVEEDORES LOCALES

            </div>

          </v-card-text>

        </v-card>
      </v-col> -->
      <!-- <v-col cols="12" md="5">

        <v-card class="panel-card" height="100%">

          <v-card-title class="panel-title">
            CONTRATOS CON PROVEEDORES LOCALES
          </v-card-title>

          <v-card-text>

            <v-row>

              <v-col cols="4">
                <div class="kpi-title">
                  Presupuesto
                </div>

                <div class="kpi-value primary--text">
                  S/ {{ Number(contratosLocales.montoContratado).toLocaleString() }}
                </div>
              </v-col>

              <v-col cols="4">
                <div class="kpi-title">
                  Consumido
                </div>

                <div class="kpi-value teal--text">
                  S/ {{ Number(contratosLocales.montoConsumidoTotal).toLocaleString() }}
                </div>
              </v-col>

              <v-col cols="4">
                <div class="kpi-title">
                  Saldo
                </div>

                <div class="kpi-value green--text">
                  S/ {{ Number(contratosLocales.saldo).toLocaleString() }}
                </div>
              </v-col>

            </v-row>

            <v-divider class="my-3"></v-divider>

            <v-row>

              <v-col cols="6">

                <v-sheet
                  outlined
                  rounded
                  class="pa-3 text-center"
                >

                  <v-icon
                    color="green"
                    large
                  >
                    mdi-map-marker-check
                  </v-icon>

                  <div class="subtitle-2 mt-2">
                    Proveedores Locales
                  </div>

                  <div class="text-h6 green--text font-weight-bold">
                    S/ {{ Number(contratosLocales.montoConsumidoLocal).toLocaleString() }}
                  </div>

                  <div class="caption">
                    {{ contratosLocales.porcentaje }} %
                  </div>

                </v-sheet>

              </v-col>

              <v-col cols="6">

                <v-sheet
                  outlined
                  rounded
                  class="pa-3 text-center"
                >

                  <v-icon
                    color="orange"
                    large
                  >
                    mdi-domain
                  </v-icon>

                  <div class="subtitle-2 mt-2">
                    No Locales
                  </div>

                  <div class="text-h6 orange--text font-weight-bold">
                    S/ {{ Number(contratosLocales.montoConsumidoNoLocal).toLocaleString() }}
                  </div>

                </v-sheet>

              </v-col>

            </v-row>

            <div class="mt-5">

              <div class="d-flex justify-space-between mb-1">

                <span class="font-weight-medium">
                  Consumo Local del Presupuesto
                </span>

                <span class="font-weight-bold">
                  {{ contratosLocales.porcentaje }} %
                </span>

              </div>

              <v-progress-linear
                :value="contratosLocales.porcentaje"
                color="green"
                background-color="#E0E0E0"
                height="18"
                rounded
              />

            </div>

            <div class="mt-4">

              <div class="d-flex justify-space-between mb-1">

                <span class="font-weight-medium">
                  Consumo Total del Presupuesto
                </span>

                <span class="font-weight-bold">
                  {{ contratosLocales.porcentajeTotal }} %
                </span>

              </div>

              <v-progress-linear
                :value="contratosLocales.porcentajeTotal"
                color="#0095A9"
                background-color="#E0E0E0"
                height="18"
                rounded
              />

            </div>

          </v-card-text>

        </v-card>

      </v-col> -->
      <v-col cols="12" md="5">
        <v-card class="panel-card" height="100%">

          <v-card-title class="panel-title">
            CONTRATOS CON PROVEEDORES LOCALES
          </v-card-title>

          <!-- ===================== -->
          <!-- CON PRESUPUESTO -->
          <!-- ===================== -->
          <v-card-text v-if="contratosLocales.montoContratado > 0">

            <v-row align="center">

              <v-col cols="5">

                <div class="monto-box">

                  <div class="monto-label">
                    PRESUPUESTO MENSUAL
                  </div>

                  <div class="monto-value">
                    S/
                    {{ Number(contratosLocales.montoContratado).toLocaleString('es-PE',{
                      minimumFractionDigits:2,
                      maximumFractionDigits:2
                    }) }}
                  </div>

                </div>

              </v-col>

              <v-col cols="4">

                <div class="monto-box">

                  <div class="monto-label">
                    CONSUMO LOCAL
                  </div>

                  <div class="monto-value green--text">
                    S/
                    {{ Number(contratosLocales.montoConsumidoLocal).toLocaleString('es-PE',{
                      minimumFractionDigits:2,
                      maximumFractionDigits:2
                    }) }}
                  </div>

                </div>

              </v-col>

              <v-col
                cols="3"
                class="text-center"
              >

                <div class="icon-circle">

                  <v-icon
                    size="72"
                    color="#0095A9"
                  >
                    mdi-map-marker-account-outline
                  </v-icon>

                </div>

              </v-col>

            </v-row>

            <v-progress-linear
              :value="contratosLocales.porcentaje"
              height="22"
              color="#0095A9"
              background-color="#E6E6E6"
              rounded
              class="mt-3"
            >

              <strong
                :class="contratosLocales.porcentaje < 60 ? 'black--text' : 'white--text'"
              >
                {{ contratosLocales.porcentaje }}%
              </strong>

            </v-progress-linear>

            <div class="porcentaje-text mb-4">

              CONSUMO LOCAL DEL PRESUPUESTO

            </div>

            <v-divider></v-divider>

            <v-row class="mt-3">

              <v-col cols="6" class="estado-item">
                <v-icon small color="green">mdi-check-circle</v-icon>
                <span class="ml-2 grey--text text--darken-1">Consumo Local</span>
                <div class="subtitle-1 green--text">
                  S/ {{ Number(contratosLocales.montoConsumidoLocal).toLocaleString() }}
                </div>
              </v-col>

              <v-col cols="6" class="estado-item">
                <v-icon small color="orange">mdi-office-building</v-icon>
                <span class="ml-2 grey--text text--darken-1">Consumo No Local</span>
                <div class="subtitle-1 orange--text">
                  S/ {{ Number(contratosLocales.montoConsumidoNoLocal).toLocaleString() }}
                </div>
              </v-col>

              <v-col cols="6" class="estado-item">
                <v-icon small color="blue">mdi-cash-multiple</v-icon>
                <span class="ml-2 grey--text text--darken-1">Consumo Total</span>
                <div class="subtitle-1 blue--text text--darken-2">
                  S/ {{ Number(contratosLocales.montoConsumidoTotal).toLocaleString() }}
                </div>
              </v-col>

              <v-col cols="6" class="estado-item">
                <v-icon small color="teal">mdi-wallet-outline</v-icon>
                <span class="ml-2 grey--text text--darken-1">Saldo Disponible</span>
                <div class="subtitle-1 teal--text text--darken-2">
                  S/ {{ Number(contratosLocales.saldo).toLocaleString() }}
                </div>
              </v-col>

            </v-row>

            <v-row>

              <v-col cols="6">

                <div class="caption grey--text">
                  Saldo Disponible
                </div>

                <div class="subtitle-1 font-weight-bold green--text">
                  S/
                  {{ Number(contratosLocales.saldo).toLocaleString('es-PE',{
                    minimumFractionDigits:2,
                    maximumFractionDigits:2
                  }) }}
                </div>

              </v-col>

              <v-col cols="6">

                <div class="caption grey--text">
                  Ejecución Total
                </div>

                <div class="subtitle-1 font-weight-bold">
                  {{ contratosLocales.porcentajeTotal }}%
                </div>

              </v-col>

            </v-row>

          </v-card-text>

          <!-- ===================== -->
          <!-- SIN PRESUPUESTO -->
          <!-- ===================== -->

          <v-card-text
            v-else
            class="text-center py-10"
          >

            <v-icon
              size="72"
              color="orange"
            >
              mdi-cash-remove
            </v-icon>

            <div class="text-h6 mt-4 font-weight-medium">
              Presupuesto mensual no registrado
            </div>

            <div class="grey--text mt-3">

              Para visualizar el avance de contratación con proveedores
              locales es necesario registrar primero el presupuesto
              mensual de la empresa contratista.

            </div>

            <v-btn
              v-if="esAdministrador"
              color="#0095A9"
              dark
              class="mt-5"
              @click="$router.push('/presupuestocontratista')"
            >

              <v-icon left>
                mdi-plus-circle
              </v-icon>

              Registrar presupuesto

            </v-btn>

          </v-card-text>

        </v-card>
      </v-col>

    </v-row>

    <v-row>
      <!-- Estado de los requerimientos -->
      <v-col cols="12" md="5">
        <v-card class="panel-card" height="100%">

          <v-card-title class="panel-title">
            ESTADO DE LOS REQUERIMIENTOS
          </v-card-title>

          <v-card-text class="pa-2">

            <v-row no-gutters>

              <!-- Gráfico -->
              <v-col cols="9">

                <div v-if="cargandoGraficos" class="text-center pa-8">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="50"
                  />
                </div>

                <apexchart
                  type="bar"
                  height="240"
                  :options="estadoOptions"
                  :series="estadoSeries"
                />

              </v-col>

              <!-- Panel derecho -->
              <v-col
                cols="3"
                class="d-flex"
              >

                <div class="total-requerimientos">

                  <div class="total-title">
                    TOTAL<br>
                    REQUERIMIENTOS
                  </div>

                  <v-progress-circular
                    v-if="cargandoGraficos"
                    indeterminate
                    size="20"
                    width="2"
                    color="primary"
                  />

                  <div class="total-value" v-else>
                    {{ totalRequerimientos }}
                  </div>

                  <v-divider class="my-3"></v-divider>

                  <div class="total-label">
                    Última actualización
                  </div>

                  <div class="total-date">
                    {{ fechaActualizacion }}
                  </div>

                </div>

              </v-col>

            </v-row>

          </v-card-text>

        </v-card>
      </v-col>

      <!-- Motivos -->
      <v-col cols="12" md="4">
        <v-card class="panel-card" height="100%">

          <v-card-title class="panel-title">
            MOTIVOS DE NO ADJUDICACIÓN
          </v-card-title>

          <v-card-text>

            <apexchart
              type="bar"
              height="240"
              :options="motivosOptions"
              :series="motivosSeries"
            />

          </v-card-text>

        </v-card>
      </v-col>

      <!-- Facturas -->
      <v-col cols="12" md="3">
        <v-card class="panel-card" height="100%">

          <v-card-title class="panel-title">
            FACTURAS POR VENCER (PRÓXIMOS 30 DÍAS)
          </v-card-title>

          <v-skeleton-loader
            v-if="cargandoGraficos"
            type="table"
            class="mx-2"
          />
          <v-data-table
            v-else
            :headers="headersFacturas"
            :items="facturas"
            ddense
            hide-default-footer
            disable-pagination
            fixed-header
            height="320"
            class="elevation-0"
          >
            <template v-slot:header.numero="{ header }">
              <span style="white-space: pre-line;">
                {{ header.text }}
              </span>
            </template>
            <template v-slot:item.numero="{ item }">
              <div class="factura-cell">
                <div class="font-weight-medium">{{ item.numero }}</div>
                <div
                  class="caption grey--text text-truncate"
                  :title="item.empresa"
                >
                  {{ item.empresa }}
                </div>
              </div>
            </template>
            <template v-slot:item.dias="{ item }">
              <v-chip
                x-small
                color="amber lighten-4"
                text-color="orange darken-4"
              >
                {{ item.dias }} días
              </v-chip>
            </template>

          </v-data-table>

        </v-card>
      </v-col>
    </v-row>




    <!-- 

    <v-row dense class="mt-5">

      <v-col cols="12" md="4">


        <v-card class="panel-card">


          <v-card-title>


            <v-icon
              left
              color="#FF6600"
            >
              mdi-file-document-outline
            </v-icon>


            Requerimientos


          </v-card-title>



          <v-card-text>



            <div class="info-row">

              <span>
                Publicados
              </span>

              <strong>
                {{ resumenRequerimientos.publicados }}
              </strong>

            </div>



            <div class="info-row">

              <span>
                En proceso
              </span>

              <strong>
                {{ resumenRequerimientos.en_proceso }}
              </strong>

            </div>



            <div class="info-row">

              <span>
                Cerrados
              </span>

              <strong>
                {{ resumenRequerimientos.cerrados }}
              </strong>

            </div>



            <div class="info-row">

              <span>
                Vencidos
              </span>

              <strong>
                {{ resumenRequerimientos.vencidos }}
              </strong>

            </div>



          </v-card-text>


        </v-card>


      </v-col>

      <v-col cols="12" md="4">


        <v-card class="panel-card">


          <v-card-title>


            <v-icon
              left
              color="#7B61FF"
            >
              mdi-domain
            </v-icon>


            Empresas participantes


          </v-card-title>




          <v-card-text>



            <div class="info-row">

              <span>
                Total empresas
              </span>

              <strong>
                {{ resumenEmpresas.total_empresas }}
              </strong>

            </div>



            <div class="info-row">

              <span>
                Postulantes
              </span>

              <strong>
                {{ resumenEmpresas.empresas_postulantes }}
              </strong>

            </div>




            <div class="info-row">

              <span>
                Adjudicadas
              </span>

              <strong>
                {{ resumenEmpresas.empresas_adjudicadas }}
              </strong>

            </div>




            <div class="info-row">

              <span>
                Nuevas
              </span>

              <strong>
                {{ resumenEmpresas.nuevas_empresas }}
              </strong>

            </div>



          </v-card-text>


        </v-card>


      </v-col>

      <v-col cols="12" md="4">


        <v-card class="panel-card">


          <v-card-title>


            <v-icon
              left
              color="#BABB13"
            >
              mdi-account-multiple-check
            </v-icon>


            Postulaciones


          </v-card-title>



          <v-card-text>


            <div class="info-row">
              <span>
                Recibidas
              </span>

              <strong>
                {{ resumenPostulaciones.recibidas }}
              </strong>
            </div>



            <div class="info-row">
              <span>
                En evaluación
              </span>

              <strong>
                {{ resumenPostulaciones.evaluacion }}
              </strong>
            </div>




            <div class="info-row">
              <span>
                Aceptadas
              </span>

              <strong>
                {{ resumenPostulaciones.aceptadas }}
              </strong>
            </div>



            <div class="info-row">
              <span>
                Rechazadas
              </span>

              <strong>
                {{ resumenPostulaciones.rechazadas }}
              </strong>
            </div>



          </v-card-text>


        </v-card>


      </v-col>


      <v-col cols="12" md="4">


        <v-card class="panel-card">


          <v-card-title>

            <v-icon
              left
              color="#00A86B"
            >
              mdi-file-sign
            </v-icon>

            Contratos

          </v-card-title>



          <v-card-text>


            <div class="info-row">
              <span>
                Activos
              </span>

              <strong>
                {{ resumenContratos.contratos_activos }}
              </strong>

            </div>


            <div class="info-row">

              <span>
                Finalizados
              </span>

              <strong>
                {{ resumenContratos.contratos_finalizados }}
              </strong>

            </div>


            <div class="info-row">

              <span>
                Por vencer
              </span>

              <strong>
                {{ resumenContratos.contratos_por_vencer }}
              </strong>

            </div>


            <div class="info-row">

              <span>
                Monto total
              </span>

              <strong>
                S/ {{ resumenContratos.monto_total }}
              </strong>

            </div>



          </v-card-text>


        </v-card>


      </v-col>

      <v-col cols="12" md="4">


        <v-card class="panel-card">


          <v-card-title>


            <v-icon
              left
              color="#C05026"
            >
              mdi-receipt-text-outline
            </v-icon>


            Facturación


          </v-card-title>



          <v-card-text>



            <div class="info-row">

              <span>
                Pendientes
              </span>

              <strong>
                {{ resumenFacturacion.facturas_pendientes }}
              </strong>

            </div>



            <div class="info-row">

              <span>
                Pagadas
              </span>

              <strong>
                {{ resumenFacturacion.facturas_pagadas }}
              </strong>

            </div>




            <div class="info-row">

              <span>
                Monto pendiente
              </span>

              <strong>
                S/ {{ resumenFacturacion.monto_pendiente }}
              </strong>

            </div>




            <div class="info-row">

              <span>
                Monto pagado
              </span>

              <strong>
                S/ {{ resumenFacturacion.monto_pagado }}
              </strong>

            </div>



          </v-card-text>


        </v-card>


      </v-col>



    </v-row>

    <v-row dense class="mt-5">

      <v-col cols="12" md="5">

        <v-card class="panel-card chart-card">


          <v-card-title>

            <v-icon
              left
              color="#0095A9"
            >
              mdi-chart-donut
            </v-icon>

            Estado de requerimientos

          </v-card-title>



          <v-card-text class="chart-container">

            <canvas ref="donutChart"></canvas>

          </v-card-text>


        </v-card>


      </v-col>

      <v-col cols="12" md="4">


        <v-card class="panel-card chart-card">


          <v-card-title>


            <v-icon
              left
              color="#FF6600"
            >
              mdi-chart-bar
            </v-icon>


            Motivos de no adjudicación


          </v-card-title>



          <v-card-text class="chart-container">


            <canvas ref="barChart"></canvas>


          </v-card-text>


        </v-card>


      </v-col>


      <v-col cols="12" md="3">


        <v-card class="panel-card">


          <v-card-title>


            <v-icon
              left
              color="#C05026"
            >
              mdi-calendar-alert
            </v-icon>


            Próximos vencimientos


          </v-card-title>



          <v-card-text>



            <div
              v-if="proximosVencimientos.length"
            >


              <div
                v-for="item in proximosVencimientos"
                :key="item.idrequerimiento"
                class="vencimiento-item"
              >


                <div>


                  <strong>
                    {{ item.denominacion }}
                  </strong>


                  <small>
                    {{ formatearFecha(item.fecha_fin) }}
                  </small>


                </div>



                <span
                  :class="{
                    'vencido':
                      diasRestantes(item.fecha_fin) < 0,
                    'urgente':
                      diasRestantes(item.fecha_fin) <= 7
                  }"
                >

                  {{ diasRestantes(item.fecha_fin) }}
                  días

                </span>



              </div>



            </div>



            <div
              v-else
              class="empty-text"
            >

              No existen vencimientos próximos

            </div>



          </v-card-text>


        </v-card>


      </v-col>


    </v-row>


    <v-row dense class="mt-5">


      <v-col cols="12">


        <v-card class="panel-card">


          <v-card-title>


            <v-icon
              left
              color="#7B61FF"
            >
              mdi-history
            </v-icon>


            Últimas postulaciones


          </v-card-title>





          <v-card-text>


            <v-simple-table>


              <thead>

                <tr>

                  <th>
                    Requerimiento
                  </th>

                  <th>
                    Empresa
                  </th>

                  <th>
                    Estado
                  </th>

                  <th>
                    Fecha
                  </th>

                </tr>

              </thead>



              <tbody>


                <tr
                  v-for="item in ultimasPostulaciones"
                  :key="item.idpostulacion"
                >


                  <td>

                    {{ item.denominacion || '-' }}

                  </td>


                  <td>

                    {{ item.empresa_contratista || '-' }}

                  </td>



                  <td>


                    <v-chip
                      small
                      :color="colorEstado(item.estado)"
                      dark
                    >

                      {{ item.estado }}

                    </v-chip>


                  </td>



                  <td>

                    {{ formatearFecha(item.fecha_postulacion) }}

                  </td>



                </tr>



              </tbody>



            </v-simple-table>



          </v-card-text>


        </v-card>


      </v-col>


    </v-row> -->




  </v-container>
</template>
<script>
import axios from 'axios'
import Chart from 'chart.js'
export default {
  name: 'DashboardContratista',
  data () {
    return {
      idcontratista: null,
      idusuario: null,
      postulaciones: [],
      requerimientos: [],
      req_pagos: [],
      // ==========================
      // KPI SUPERIORES
      // ==========================
      resumen: {
        activos: 0,
        evaluacion: 0,
        adjudicados: 0,
      },
      // ==========================
      // RESUMEN FINANCIERO
      // ==========================
      resumenFinanciero: {
        facturas_vencidas: {
          cantidad: 0,
          monto_soles: 0,
          monto_dolares: 0
        },

        facturas_por_vencer: {
          cantidad: 0,
          monto_soles: 0,
          monto_dolares: 0,
          dias: 15
        }
      },
      contratosLocales: {

          montoContratado:0,
          montoConsumidoLocal:0,
          montoConsumidoNoLocal:0,
          montoConsumidoTotal:0,
          saldo:0,
          porcentaje:0,
          porcentajeTotal:0

      },
      indicadoresRequerimientos: {
        total: 22,
        publicados: 18,
        regulados: 4
      },
      estadoSeries: [{
        data: [132, 95, 75, 54, 28]
      }],
      resumenProveedores: {
        locales: 0,
        no_locales: 0
      },

      // estadoOptions: {
      //   chart: {
      //     toolbar: { show: false }
      //   },
      //   colors: ['#0D8DB3'],
      //   plotOptions: {
      //     bar: {
      //       distributed: true,
      //       borderRadius: 4
      //     }
      //   },
      //   dataLabels: {
      //     enabled: true
      //   },
      //   xaxis: {
      //     categories: [
      //       'Adjudicado',
      //       'En evaluación',
      //       'En postulación',
      //       'Retirado',
      //       'No adjudicado'
      //     ]
      //   },
      //   legend: {
      //     show: false
      //   }
      // },

      // motivosSeries: [{
      //   data: [18, 14, 10, 6, 5]
      // }],

      // motivosOptions: {
      //   chart: {
      //     toolbar: { show: false }
      //   },
      //   colors: ['#0D8DB3'],
      //   plotOptions: {
      //     bar: {
      //       horizontal: true,
      //       borderRadius: 4
      //     }
      //   },
      //   dataLabels: {
      //     enabled: true
      //   },
      //   xaxis: {
      //     categories: [
      //       'Precio fuera de rango',
      //       'No cumple requisitos',
      //       'Documentación incompleta',
      //       'Experiencia no compatible',
      //       'Otros'
      //     ]
      //   },
      //   legend: {
      //     show: false
      //   }
      // },
      cargandoGraficos: true,

      estadoSeries: [],
      motivosSeries: [],

      estadoOptions: {
        chart: {
          toolbar: { show: false }
        },
        colors: ['#0D8DB3'],
        plotOptions: {
          bar: {
            distributed: true,
            borderRadius: 4
          }
        },
        dataLabels: {
          enabled: true
        },
        xaxis: {
          categories: []
        },
        legend: {
          show: false
        }
      },

      motivosOptions: {
        chart: {
          toolbar: { show: false }
        },
        colors: ['#0D8DB3'],
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 4,
            barHeight: '60%'
          }
        },
        dataLabels: {
          enabled: true
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          labels: {
            maxWidth: 80      // evita que las etiquetas ocupen demasiado
          }
        },
        grid: {
          padding: {
            left: 10,
            right: 20
          }
        },
        tooltip: {
          y: {
            formatter: val => `${val}`
          }
        },
        legend: {
          show: false
        }
      },

      contratistas: [],
      idcontratistas: "",

      headersFacturas: [
        { text: 'N° FACTURA\nEMPRESA', value: 'numero', width: '60px' },
        { text: 'DÍAS', value: 'dias', width: '90px', align: 'center' }
      ],

      facturas: [
        {
          numero: 'F001-000123',
          empresa: 'Empresa A',
          dias: 9
        },
        {
          numero: 'F001-000124',
          empresa: 'Empresa B',
          dias: 14
        },
        {
          numero: 'F001-000125',
          empresa: 'Empresa C',
          dias: 19
        },
        {
          numero: 'F001-000126',
          empresa: 'Empresa D',
          dias: 24
        },
        {
          numero: 'F001-000127',
          empresa: 'Empresa E',
          dias: 29
        }
      ],
      totalRequerimientos: 0,

      fechaActualizacion: '27/03/2025 10:28 a.m.',
      // ==========================
      // REQUERIMIENTOS
      // ==========================
      resumenRequerimientos: {
        publicados: 0,
        en_proceso: 0,
        cerrados: 0,
        vencidos: 0
      },
      // ==========================
      // EMPRESAS
      // ==========================
      resumenEmpresas: {
        total_empresas: 0,
        empresas_postulantes: 0,
        empresas_adjudicadas: 0,
        nuevas_empresas: 0
      },
      // ==========================
      // POSTULACIONES
      // ==========================
      resumenPostulaciones: {
        recibidas:0,
        evaluacion:0,
        aceptadas:0,
        rechazadas:0
      },
      // ==========================
      // CONTRATOS
      // ==========================
      resumenContratos:{
        contratos_activos:0,
        contratos_finalizados:0,
        contratos_por_vencer:0,
        monto_total:0
      },
      // ==========================
      // FACTURACION
      // ==========================
      resumenFacturacion:{
        facturas_pendientes:0,
        facturas_pagadas:0,
        monto_pendiente:0,
        monto_pagado:0
      },
      // ==========================
      // GRAFICOS
      // ==========================
      chartEstados:{
        labels:[],
        data:[]
      },
      chartRequerimientos:{
        labels:[],
        data:[]
      },

      donutChart:null,
      barChart:null,
      dashboard: {
        presupuesto: null,
        anio_presupuesto: null,
        mes_presupuesto: null,
        requerimientos_publicados: 0,
        requerimientos_en_ejecucion: 0
      },
      monto_contratado: 0,
    }
  },

  computed:{
    // Tarjetas superiores
    tarjetasKpi(){
      return [
        {
          nombre:'Activos',
          valor:this.resumen.activos,
          icon:'mdi-briefcase-outline',
          color:'#FF6600'
        },

        {
          nombre:'En evaluación',
          valor:this.resumen.evaluacion,
          icon:'mdi-clipboard-text-outline',
          color:'#0095A9'
        },

        {

          nombre:'Adjudicados',

          valor:this.resumen.adjudicados,

          icon:'mdi-trophy-outline',

          color:'#BABB13'

        },



        {

          nombre:'Postulaciones',

          valor:this.postulaciones.length,

          icon:'mdi-account-check-outline',

          color:'#7B61FF'

        },



        {

          nombre:'Requerimientos',

          valor:this.totalRequerimientos,

          icon:'mdi-file-document-outline',

          color:'#00A86B'

        },



        {

          nombre:'Pendientes',

          valor:
          this.postulaciones.filter(
            x=>x.estado==='EN_POSTULACION'
          ).length,

          icon:'mdi-clock-outline',

          color:'#C05026'

        }


      ]


    },

    proximosVencimientos(){
      return this.requerimientos
      .filter(x=>x.fecha_fin)
      .sort((a,b)=>
        new Date(a.fecha_fin) -
        new Date(b.fecha_fin)
      )
      .slice(0,5)
    },

    ultimasPostulaciones(){
      return this.postulaciones
      .slice(0,10)
    },

  },

  created(){
    this.idcontratista =
      Number(
        localStorage.getItem('empresacontratista')
      )
    this.idusuario =
      localStorage.getItem('idusuario')
    this.rol = localStorage.getItem('rol')
    this.esAdministrador =
    this.rol === 'ADMINISTRADOR'
  },
  async mounted(){
    if (this.esAdministrador) {
      await this.selectEmpresasContratistas();
    } else {
      if(this.idcontratista){
        await this.cargarDashboard()
      }
    }
  },

  methods:{
    async cargarDashboard(){
      const idContratista = this.esAdministrador
          ? this.idcontratistas
          : this.idcontratista;

      if (!idContratista) return;
      try{
        // const req =
        // await axios.get(
        //   `api/Requerimientos/RequerimientosPorContratista/${this.idusuario}`
        // )
        // this.requerimientos =
        //   req.data || []
        const res = await axios.get(
          `api/Requerimientos/RequerimientosPorContratista/${this.idcontratista}`
        );

        this.dashboard = res.data || {};
        this.resumen.activos = this.dashboard.requerimientos_publicados;
        const reqCom = this.dashboard.completados;
        this.totalRequerimientos = this.dashboard.total_requerimientos;

        this.resumenRequerimientos.publicados =
          this.dashboard.total_requerimientos;

        this.indicadoresRequerimientos.publicados =
          this.dashboard.indicadores_publicados;

        this.indicadoresRequerimientos.regulados =
          this.dashboard.indicadores_regularizados;          

        this.resumenRequerimientos.en_proceso =
          this.dashboard.requerimientos_en_proceso;

        this.resumenRequerimientos.cerrados =
          this.dashboard.requerimientos_cerrados;

        this.resumenRequerimientos.vencidos =
          this.dashboard.requerimientos_vencidos;
        this.montoContratado = this.dashboard.presupuesto;

        const post =
        await axios.get(
          `api/PostulacionEmpresas/ListarPorContratista/${this.idcontratista}`
        )
        this.postulaciones =
          post.data || []

        // this.resumen.activos =
        // this.requerimientos.filter(
        //   x=>x.estado==='ABIERTO'
        // ).length

        this.resumenProveedores = {
          locales: 0,
          noLocales: 0
        }
        // const categoriasLocales = [
        //   'Categoría B: Proveedor Local Genuino',
        //   'Categoría C: Proveedor Local en Desarrollo',
        //   'Categoría D: Proveedor Originario o Residente Local'
        // ]

        // const reqCom = this.requerimientos.filter(r =>
        //   ['CERRADO', 'REGULARIZADO_CERRADO'].includes(r.estado)
        // )

        // reqCom.forEach(req => {
        //   req.postulaciones.forEach(post => {

        //     if (post.estado !== 'ADJUDICADO') return

        //     const categoria = post.empresa?.categoria_proveedor

        //     if (categoriasLocales.includes(categoria)) {
        //       this.resumenProveedores.locales++
        //     } else {
        //       this.resumenProveedores.noLocales++
        //     }

        //   })
        // })
        this.resumenProveedores.locales = this.dashboard.monto_local_pagado;
        this.resumenProveedores.noLocales = this.dashboard.monto_no_local_pagado;
        const totalEmpresas = this.resumenProveedores.locales + this.resumenProveedores.noLocales;
        this.contratosLocales.porcentaje = this.dashboard.porcentaje_consumo_local;
        
        this.contratosLocales.montoConsumidoLocal = this.dashboard.monto_local_pagado;
        this.contratosLocales.montoConsumidoNoLocal = this.dashboard.monto_no_local_pagado;
        this.contratosLocales.montoConsumidoTotal = this.dashboard.monto_total_pagado;
        this.contratosLocales.porcentajeNoLocal = this.dashboard.porcentaje_consumo_no_local;
        this.contratosLocales.porcentajeTotal = this.dashboard.porcentaje_consumo_total;
        this.contratosLocales.saldo = this.dashboard.saldo_presupuesto;
        // this.contratosLocales.porcentaje =
        //   totalEmpresas > 0
        //     ? Number(((this.resumenProveedores.locales / totalEmpresas) * 100).toFixed(2))
        //     : 0;

        // this.totalRequerimientos = this.requerimientos.length;

        const fechaEvaluada = new Date(); // o la fecha que estés evaluando

        // this.indicadoresRequerimientos.total = this.requerimientos.filter(r => {
        //   const fecha = new Date(r.fecha_solicitud);

        //   return (
        //     fecha.getMonth() === fechaEvaluada.getMonth() &&
        //     fecha.getFullYear() === fechaEvaluada.getFullYear()
        //   );
        // }).length;
        // this.indicadoresRequerimientos.publicados = this.requerimientos.filter(
        //   x=>x.estado!=='REGULARIZADO_CERRADO'
        // ).length

        // this.indicadoresRequerimientos.regulados = this.requerimientos.filter(
        //   x=>x.estado==='REGULARIZADO_CERRADO'
        // ).length

        this.resumen.evaluacion =
        this.postulaciones.filter(
          x=>x.estado==='EN_EVALUACIÓN'
        ).length

        this.resumen.adjudicados =
        this.postulaciones.filter(
          x=>x.estado==='ADJUDICADO'
        ).length

        const req_pas =
          axios.get(`api/PostulacionEmpresas/ListarPorContratistaPagosPanel/${this.idcontratista}`)
            .then(res => {
              this.req_pagos = res.data
              this.calcularResumenFinanciero()
            })

        // this.resumenRequerimientos.publicados =
        // this.requerimientos.length

        // this.resumenRequerimientos.en_proceso =
        // this.requerimientos.filter(
        //   x=>x.estado==='EN_PROCESO'
        // ).length

        // this.resumenRequerimientos.cerrados =
        // this.requerimientos.filter(
        //   x=>x.estado==='CERRADO'
        // ).length

        // this.resumenRequerimientos.vencidos =
        // this.requerimientos.filter(
        //   x=>this.diasRestantes(x.fecha_fin)<0
        // ).length

        // ==========================
        // POSTULACIONES
        // ==========================

        this.resumenPostulaciones.recibidas =
        this.postulaciones.length

        this.resumenPostulaciones.evaluacion =
        this.postulaciones.filter(
          x=>x.estado==='EN_EVALUACIÓN'
        ).length

        this.resumenPostulaciones.aceptadas =
        this.postulaciones.filter(
          x=>x.estado==='ADJUDICADO'
        ).length

        this.resumenPostulaciones.rechazadas =
        this.postulaciones.filter(
          x=>x.estado==='RECHAZADO'
        ).length

        // ==========================
        // EMPRESAS
        // ==========================

        this.resumenEmpresas.empresas_postulantes =
        new Set(
          this.postulaciones.map(
            x=>x.idempresa
          )
        ).size

        // ==========================
        // GRAFICOS
        // ==========================

        let estados={}
        let motivos={}

        this.postulaciones.forEach(p=>{


          estados[p.estado]=
          (estados[p.estado]||0)+1



          if(
            p.tipo_respuesta &&
            p.id_tipo_respuesta!==1
          ){

            motivos[p.tipo_respuesta]=
            (motivos[p.tipo_respuesta]||0)+1

          }


        })




        this.chartEstados={

          labels:Object.keys(estados),

          data:Object.values(estados)

        }





        this.chartRequerimientos={
          labels:Object.keys(motivos),
          data:Object.values(motivos)
        }
        this.$nextTick(()=>{
          // this.renderDonut()
          this.renderEstadosReq()
          this.cargandoGraficos = false;
          // this.renderBar()
        })
      }
      catch(error){

        console.error(
          'Error dashboard',
          error
        )
      }
    },
    renderEstadosReq(){
      const estados = {};
      const motivos = {};
      this.postulaciones.forEach(p => {
        // Estados
        estados[p.estado] = (estados[p.estado] || 0) + 1;
        // Motivos
        if (
          p.tipo_respuesta &&
          p.id_tipo_respuesta !== 1
        ) {
          motivos[p.tipo_respuesta] =
            (motivos[p.tipo_respuesta] || 0) + 1;
        }

      });
      this.estadoOptions = {
        ...this.estadoOptions,
        xaxis: {
          ...this.estadoOptions.xaxis,
          categories: Object.keys(estados)
        }
      }

      this.estadoSeries = [{
        name: 'Postulados',
        data: Object.values(estados)
      }]

      // Gráfico de motivos
      this.motivosOptions = {
        ...this.motivosOptions,
        xaxis: {
          ...this.motivosOptions.xaxis,
          categories: Object.keys(motivos)
        }
      }

      this.motivosSeries = [{
        name: 'Postulaciones',
        data: Object.values(motivos)
      }]
    },
    renderDonut(){

      if(this.donutChart){
        this.donutChart.destroy()
      }

      this.donutChart = new Chart(
        this.$refs.donutChart,
        {
          type:'doughnut',
          data:{
            labels:this.chartEstados.labels,
            datasets:[{
              data:this.chartEstados.data,
              backgroundColor:[
                '#0095A9',
                '#BABB13',
                '#FF6600',
                '#7B61FF',
                '#00A86B'
              ]
            }]
          },
          options:{
            responsive:true,
            maintainAspectRatio:false
          }
        }
      )
    },

    renderBar(){

      if(this.barChart){
        this.barChart.destroy()
      }

      this.barChart = new Chart(
        this.$refs.barChart,
        {
          type:'bar',
          data:{
            labels:this.chartRequerimientos.labels,
            datasets:[{
              data:this.chartRequerimientos.data,
              backgroundColor:'#0095A9'
            }]
          },
          options:{
            responsive:true,
            maintainAspectRatio:false,
            legend:{
              display:false
            },
            scales:{
              yAxes:[
                {
                  ticks:{
                    beginAtZero:true
                  }
                }
              ]
            }
          }
        }
      )
    },

    diasRestantes(fecha){

      if(!fecha) return 0

      const hoy = new Date()
      const fin = new Date(fecha)

      return Math.ceil(
        (fin-hoy)/(1000*60*60*24)
      )
    },

    formatearFecha(fecha){

      if(!fecha) return '-'

      return fecha
        .split('T')[0]
        .split('-')
        .reverse()
        .join('/')
    },

    colorEstado(estado){

      const colores = {
        'ADJUDICADO':'green',
        'EN_EVALUACIÓN':'orange',
        'RECHAZADO':'red',
        'REGISTRADO':'blue'
      }

      return colores[estado] || 'grey'
    },

    diasTranscurridos (fecha) {
      const hoy = new Date()
      const emision = new Date(fecha)
      return Math.floor((hoy - emision) / (1000 * 60 * 60 * 24))
    },

    estadoTexto(f) {
      if (f.estado_pago === 'PAGADO') return 'PAGADO'
      const d = this.diasTranscurridos(f.fecha_emision)
      if (d >= 30) return 'VENCIDO'
      if (d >= 15) return 'POR VENCER'

      return 'EN PLAZO'
    },

    calcularResumenFinanciero() {
      this.facturas = [];
      // Reiniciar
      this.resumenFinanciero = {
        facturas_vencidas: {
          cantidad: 0,
          monto_soles: 0,
          monto_dolares: 0
        },
        facturas_por_vencer: {
          cantidad: 0,
          monto_soles: 0,
          monto_dolares: 0,
          dias: 15
        }
      }
      let montoContratado = 0;
      let montoConsumido = 0;

      this.req_pagos.forEach(req => {

        req.empresas.forEach(empresa => {

          empresa.facturas.forEach(factura => {

            const monto = Number(factura.monto || 0);
            if (factura.moneda !== 'USD') {

              // Total contratado (todas las facturas en soles)
              montoContratado += monto;

              // Consumido = pagado en soles
              if (factura.estado_pago === 'PAGADO') {
                montoConsumido += monto;
              }
            }

            const estado = this.estadoTexto(factura);
            const dias = this.diasTranscurridos(factura.fecha_emision);

            if (estado === 'VENCIDO') {

              this.resumenFinanciero.facturas_vencidas.cantidad++;

              if (factura.moneda === 'USD') {
                this.resumenFinanciero.facturas_vencidas.monto_dolares += Number(factura.monto);
              } else {
                this.resumenFinanciero.facturas_vencidas.monto_soles += Number(factura.monto);
              }

            } else if (estado === 'POR VENCER') {

              this.resumenFinanciero.facturas_por_vencer.cantidad++;

              if (factura.moneda === 'USD') {
                this.resumenFinanciero.facturas_por_vencer.monto_dolares += Number(factura.monto);
              } else {
                this.resumenFinanciero.facturas_por_vencer.monto_soles += Number(factura.monto);
              }

              this.facturas.push({
                numero: factura.numero_factura,
                empresa: empresa.razonsocial,
                dias: dias
              });

            }

          });

        });

      });
      montoContratado = this.montoContratado
      this.facturas.sort((a, b) => b.dias - a.dias);
      // this.contratosLocales.montoContratado = montoContratado.toFixed(2);
      this.contratosLocales.montoContratado = montoContratado;
      this.contratosLocales.montoConsumido = montoConsumido.toFixed(2);

    },
    async cambiarContratista(id) {
      this.idcontratista = id;
      await this.cargarDashboard();
    },
    async selectEmpresasContratistas() {
      try {

        const res = await axios.get("api/Contratistas/Select");

        this.contratistas = res.data.map(x => ({
          text: x.empresa_contratista,
          value: x.id_empresa_contratista
        }));

        // Si es administrador y no hay empresa seleccionada
        if (this.esAdministrador &&
            !this.idcontratistas &&
            this.contratistas.length > 0) {

          this.idcontratistas = this.contratistas[0].value;
          this.idcontratista = this.idcontratistas;

          await this.cargarDashboard();
        }

      } catch (error) {
        console.log(error.response);
      }
    }

  }
}
</script>
<style scoped>
.dashboard-container {
  background: #f7f8fa;
  min-height: 100vh;
  padding: 20px;
}

/* KPI SUPERIORES */
.kpi-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  padding: 18px;
  height: 120px;
  transition: .2s;
}

.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0,0,0,.08);
}

.kpi-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.kpi-number {
  font-size: 36px;
  font-weight: 800;
  line-height: 1;
}

.kpi-label {
  margin-top: 8px;
  color: #666;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
}


/* PANELES */
.panel-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  height: 100%;
  overflow: hidden;
}

.panel-card .v-card__title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  background: #fafafa;
  border-bottom: 1px solid #eeeeee;
}


/* FILAS INFORMACION */
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #eeeeee;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row span {
  color: #666;
  font-size: 14px;
}

.info-row strong {
  color: #333;
  font-size: 16px;
  font-weight: 700;
}


/* GRAFICOS */
.chart-card {
  height: 380px;
}

.chart-container {
  height: 310px;
  position: relative;
}

.chart-container canvas {
  max-height: 280px;
}


/* VENCIMIENTOS */
.vencimiento-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
}

.vencimiento-item strong {
  display: block;
  font-size: 13px;
  max-width: 170px;
}

.vencimiento-item small {
  color: #777;
  display: block;
  margin-top: 4px;
}

.vencimiento-item span {
  background: #0095A9;
  color: white;
  border-radius: 20px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 700;
}

.vencimiento-item span.urgente {
  background: #FF6600;
}

.vencimiento-item span.vencido {
  background: #C05026;
}


/* TABLA */
.v-card table {
  width: 100%;
}

.v-card th {
  font-size: 12px !important;
  color: #666 !important;
  font-weight: 700;
}

.v-card td {
  font-size: 13px !important;
}


/* TEXTOS VACIOS */
.empty-text {
  text-align: center;
  color: #999;
  padding: 25px 0;
}


/* CHIPS */
.v-chip {
  font-size: 11px;
  font-weight: 600;
}


/* RESPONSIVE */
@media(max-width:960px){

  .kpi-card {
    height: auto;
  }

  .kpi-number {
    font-size: 30px;
  }

}
.finance-box {
  display: flex;
  align-items: center;
  padding: 15px;
  min-height: 110px;
  border-radius: 4px;
  margin-bottom: 10px;
  background: #fff7f5; /* fondo rojo muy tenue */
  border: 1px solid #f5e1dc;
}


.finance-icon {
  width:60px;
  text-align:center;
}


.finance-main {
  margin-left:10px;
  min-width:90px;
}


.finance-number {
  font-size:34px;
  font-weight:800;
  color:#333;
}


.finance-label {
  font-size:11px;
  font-weight:700;
  color:#666;
}


.finance-sub {
  font-size:11px;
  color:#777;
}



.finance-money {
  margin-left:auto;
  display:flex;
  flex-direction:column;
}


.finance-money strong {
  color:#C05026;
  font-size:18px;
}


.finance-money .usd {
  color:#0066CC;
  margin-top:8px;
}


.finance-money small {
  font-size:10px;
  color:#777;
}


.por-vencer .finance-number {
  color:#D49B00;
}

.requerimientos-total {
  font-size: 34px;
  font-weight: 700;
  color: #0095A9;
  line-height: 1;
}

.requerimientos-title {
  font-size: 13px;
  font-weight: 700;
  color: #555;
}

.requerimientos-subtitle {
  font-size: 11px;
  color: #888;
}

.detalle-numero {
  font-size: 28px;
  font-weight: 700;
  color: #0095A9;
}

.detalle-texto {
  font-size: 11px;
  color: #666;
  line-height: 1.3;
  margin-top: 6px;
}

.ver-link {
  color: #0095A9;
  font-size: 13px;
  text-decoration: none;
  font-weight: 600;
}

.total-requerimientos{
    width:100%;
    height:240px;
    border-left:1px solid #E5E5E5;

    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;

    text-align:center;
    padding:0 8px;
}

.total-title{
    font-size:10px;
    font-weight:700;
    color:#666;
    text-transform:uppercase;
    line-height:1.3;
}

.total-value{
    margin:12px 0;
    font-size:42px;
    font-weight:700;
    color:#0095A9;
    line-height:1;
}

.total-label{
    font-size:10px;
    color:#9E9E9E;
}

.total-date{
    margin-top:4px;
    font-size:10px;
    color:#616161;
    font-weight:600;
}

.kpi-destacado {
  min-height: 170px;
}

.kpi-destacado .kpi-number {
  font-size: 55px;
}

.kpi-destacado .v-icon {
  transform: scale(1.25);
}
.factura-cell{
    width: 140px;
}

.factura-cell .caption{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.tabla-facturas table{
    table-layout: fixed;
}

.monto-box{
  text-align:center;
}

.monto-label{
  font-size:11px;
  font-weight:600;
  color:#78909C;
  text-transform:uppercase;
  letter-spacing:.4px;
  margin-bottom:6px;
}

.monto-value{
  font-size:22px;
  font-weight:700;
  color:#263238;
}

.icon-circle{
  width:90px;
  height:90px;
  border-radius:50%;
  background:#E8F7FA;
  display:flex;
  align-items:center;
  justify-content:center;
  margin:auto;
}

.porcentaje-text{
  margin-top:10px;
  text-align:center;
  font-size:13px;
  color:#607D8B;
  font-weight:600;
}

.caption{
  font-size:12px !important;
  color:#78909C !important;
}

.subtitle-1{
  font-size:18px !important;
  font-weight:700 !important;
}

.v-progress-linear{
  border-radius:20px;
}

.v-progress-linear__content{
  font-size:13px;
  font-weight:700;
}

.estado-item{
  padding:8px 0;
}

.estado-item:not(:last-child){
  border-bottom:1px dashed #ECEFF1;
}
</style>